import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { NationalQualificationsFrameworkDescriptorsSideMenuComponent } from './nqfs-details-side-menu/national-qualifications-framework-descriptors-side-menu.component';

@Component({
  selector: 'app-nqf-descriptors',
  imports: [
    NationalQualificationsFrameworkDescriptorsSideMenuComponent,
    TranslateModule,
    RouterOutlet,
  ],
  templateUrl: './nqf-descriptors.component.html',
  styleUrl: './nqf-descriptors.component.scss',
})
export class NqfDescriptorsComponent {
  constructor() {}

  private readonly destroy$ = new Subject<void>();
  limit = 15;

  ngOnInit() {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
